export default "__VITE_ASSET__BU9pXisr__"